import { useCallback, Key, useState } from 'react';
import { useBlacklistFilterChanges } from '../useBlacklistFilterChanges/useBlacklistFilterChanges';
import { BlacklistRequest } from '../../../../../store/reducers/BlacklistSlice';
import { ReasonTypes } from '../../types';

interface Props {
  onCallRequest: (value: BlacklistRequest) => void;
  callRequest: BlacklistRequest;
}

export const useBlacklistHandlersFilter = ({
  onCallRequest,
  callRequest,
}: Props) => {
  const { handleReason } = useBlacklistFilterChanges({
    onCallRequest,
    callRequest,
  });

  const [reasonValue, setReasonValue] = useState<ReasonTypes | null>(null);

  const handleReasonChange = (value: ReasonTypes | null = null) => {
    setReasonValue(value);
    handleReason(value);
  };

  const handleOpenReason = useCallback(
    (open: boolean) => {
      if (!open) {
        handleReason(reasonValue);
      }
    },
    [handleReason, reasonValue],
  );

  return {
    handleReasonChange,
    reasonValue,
    handleOpenReason,
  };
};
